import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { SidebarNav } from './sidebar-nav'
import { TopNav } from './top-nav'
import { useIsMobile } from '@/hooks/use-mobile'
import { LanguageProvider } from '@/contexts/language-context'

export function AuthenticatedLayout() {
  const isMobile = useIsMobile()
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <LanguageProvider>
      <div className="flex h-screen bg-background">
        {/* Desktop Sidebar */}
        {!isMobile && (
          <SidebarNav
            collapsed={sidebarCollapsed}
            onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
          />
        )}

        {/* Mobile Sidebar (Sheet) */}
        {isMobile && (
          <SidebarNav isMobile isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
        )}

        {/* Main Content Area */}
        <div className="flex flex-1 flex-col overflow-hidden">
          <TopNav onMobileMenuToggle={() => setMobileMenuOpen(true)} />
          <main className="flex-1 overflow-y-auto p-4 sm:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </LanguageProvider>
  )
}
